import { Link, NavLink } from 'react-router-dom'
import { getActiveWargameConfig } from '@gamecodex/wargame-config'
import { useCartStore, cartCount } from '@/features/store/cartStore'
import { KickstarterCTA } from '@/components/KickstarterCTA'

const BASE_NAV = [
  { to: '/', label: 'Home', end: true },
  { to: '/how-to-play', label: 'How to Play' },
  { to: '/build', label: 'Build Your Titan' },
  { to: '/play', label: 'Play' },
]

export function TopNav() {
  const cfg = getActiveWargameConfig()
  const cartItems = useCartStore((s) => s.items)
  const count = cartCount(cartItems)
  const nav = cfg.store?.enabled ? [...BASE_NAV, { to: '/store', label: 'Store', end: false }] : BASE_NAV

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-black/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
        <Link to="/" className="flex items-center gap-2 font-black uppercase tracking-widest text-white">
          {cfg.branding.logoIsWordmark ? (
            <img src={cfg.branding.images.logo} alt={cfg.wargameName} className="h-7 w-auto object-contain" />
          ) : (
            <>
              <img src={cfg.branding.images.logo} alt={cfg.wargameName} className="h-8 w-8 object-contain" />
              {cfg.wargameName}
            </>
          )}
        </Link>
        <nav className="flex items-center gap-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `relative rounded px-3 py-1.5 text-xs font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? 'bg-[var(--wg-primary)] text-black' : 'text-white/70 hover:text-white'
                }`
              }
            >
              {n.label}
              {n.to === '/store' && count > 0 && (
                <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--wg-accent)] px-1 text-[9px] font-bold text-black">
                  {count}
                </span>
              )}
            </NavLink>
          ))}
          <KickstarterCTA size="sm" className="ml-2" />
        </nav>
      </div>
    </header>
  )
}
